import { HugeiconsIcon, type IconSvgElement } from "@hugeicons/react";
import type { UntitledIcon } from "../../types/untitled-icon";
import { cx } from "../../utils";

export enum IconSize {
  SM = "SM",
  BASE = "BASE",
  LG = "LG"
}

export const IconBridge = ({
  HugeIcon,
  size,
  Icon,
  className,
  strokeWidth
}: {
  HugeIcon?: IconSvgElement;
  size: IconSize;
  Icon?: UntitledIcon;
  className?: string;
  strokeWidth?: number;
}) => {
  if (HugeIcon) {
    return (
      <HugeiconsIcon
        icon={HugeIcon}
        size={size === IconSize.LG ? "24" : "20"}
        stroke="inherit"
        strokeWidth={strokeWidth || 2}
        className={cx("shrink-0", className)}
      />
    );
  }
  if (Icon)
    return (
      <Icon
        size={size === IconSize.LG ? "24" : "20"}
        stroke="inherit"
        className={cx("shrink-0", className)}
      />
    );

  return null;
};
